import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import EnvironementGenerator from './EnvironementGenerator.js';
import UIGenerator from './UIGenerator.js';

export default class UIConnector {

	constructor(envGenerator, uiGenerator) {
		this.envGenerator = envGenerator;
		this.uiGenerator = uiGenerator;
	}

	SetConfigDiv(div) {
		this.configDiv = div;
	}

	ExportLink() {
		const linkInput = document.getElementById("link");
		linkInput.value = this.envGenerator.GenerateLink();
	}
	
	SetZone(zone, room) {
		this.zone = zone;
		this.currentRoom = room;
	}

	SetupConfigType(value) {
		this.currentConfigType = value;
	}

	ChangeConfigType(value, data) {
		this.currentConfigType = value;
		//this.envGenerator.ResetBaseConfig();
		this.envGenerator.ChangeConfigType(value);
		this.configDiv.innerHTML = "";
		var afficherConfigEcranMural = true;
		switch(value) {
			case "Theatre":
				if (data) {
					this.uiGenerator.AddTextElement("Nombre de personnes : " + data.d.nbc, "chaiseCount", this.configDiv);
				}
				else {
					switch(this.currentRoom) {
						case "1":
							this.uiGenerator.AddTextElement("Nombre de personnes : 176", "chaiseCount", this.configDiv);

							var functionToSend = function(e){
								this.envGenerator.ChangeConfigValue({type: "switchOrientation", value: e.target.checked});
							}.bind(this);
							this.uiGenerator.AddCheckboxElement("Tourné écran mural ", "ecranMural", false, functionToSend, this.configDiv);

							break;
						case "2":
							afficherConfigEcranMural = false;
							this.uiGenerator.AddTextElement("Nombre de personnes : 225", "chaiseCount", this.configDiv);
							break;
						case "3":
							afficherConfigEcranMural = false;
							this.uiGenerator.AddTextElement("Nombre de personnes : 160", "chaiseCount", this.configDiv);
							break;
						case "1_2":
							this.uiGenerator.AddTextElement("Nombre de personnes : 381", "chaiseCount", this.configDiv);
							break;
						case "2_3":
							afficherConfigEcranMural = false;
							this.uiGenerator.AddTextElement("Nombre de personnes : 471", "chaiseCount", this.configDiv);
							break;
						case "1_2_3":
							this.uiGenerator.AddTextElement("Nombre de personnes : 596", "chaiseCount", this.configDiv);
							break;
						case "4":
							this.uiGenerator.AddTextElement("Nombre de personnes : 24", "chaiseCount", this.configDiv);
							break;
						case "5":
							this.uiGenerator.AddTextElement("Nombre de personnes : 70", "chaiseCount", this.configDiv);
							break;
						case "6":
							this.uiGenerator.AddTextElement("Nombre de personnes : 100", "chaiseCount", this.configDiv);
							break;
						case "7":
							this.uiGenerator.AddTextElement("Nombre de personnes : 130", "chaiseCount", this.configDiv);
							break;
						case "8":
							this.uiGenerator.AddTextElement("Nombre de personnes : 154", "chaiseCount", this.configDiv);
							break;
						case "9":
							this.uiGenerator.AddTextElement("Nombre de personnes : 121", "chaiseCount", this.configDiv);
							break;
						case "10":
							this.uiGenerator.AddTextElement("Nombre de personnes : 74", "chaiseCount", this.configDiv);
							break;
						case "11":
							this.uiGenerator.AddTextElement("Nombre de personnes : 24", "chaiseCount", this.configDiv);
							break;
						case "Lully":
							afficherConfigEcranMural = false;
							this.uiGenerator.AddTextElement("Nombre de place dans la tribune : 500", "chaiseCount", this.configDiv);
							break;
						default:
					}

					if (afficherConfigEcranMural) {
						var functionToSend = function(e){
							this.envGenerator.ChangeConfigValue({type: "isEcranMural", value: e.target.checked});
						}.bind(this);
						this.uiGenerator.AddCheckboxElement("Afficher ecran mural ", "isEcranMural", false, functionToSend, this.configDiv);
					}
				}
				if (this.zone != "Lully") {
					if (this.zone == "Room_1_3") {
						var functionToSend = function(e){
							this.envGenerator.ChangeConfigValue({type: "praticable", value: e.target.checked});
						}.bind(this);
						this.uiGenerator.AddCheckboxElement("Avec praticable ", "praticable", false, functionToSend, this.configDiv);
					}

					functionToSend = function(e){
						this.envGenerator.ChangeConfigValue({type: "entreRange", value: e.target.value/10});
						this.uiGenerator.ChangeTextElement("entreRange-text", "Espace minimum entre les rangés : " + ((e.target.value - 5) / 10) + "m");
						this.uiGenerator.ChangeTextElement("chaiseCount", "Nombre de personnes : " + this.envGenerator.GetConfigData().chaiseCount);
					}.bind(this);
					this.uiGenerator.AddRangeInputElement("Espace entre les rangés : " + (data?(data.d.er*10-5)/10:0.5) + "m", "entreRange", {default: data?data.d.er*10:10, max:30, min:10, step: 1}, functionToSend, this.configDiv);

					this.uiGenerator.AddTextElement("Déplacer l'allée centrale", "alleCentrale", this.configDiv);
					functionToSend = function(e){
						this.envGenerator.ChangeConfigValue({type: "rangeOffset", value: -1});
					}.bind(this);
					this.uiGenerator.AddButton("Gauche", this.configDiv, functionToSend, ["button-1-2"]);

					functionToSend = function(e){
						this.envGenerator.ChangeConfigValue({type: "rangeOffset", value: 1});
					}.bind(this);
					this.uiGenerator.AddButton("Droite", this.configDiv, functionToSend, ["button-1-2"]);
				}
				break;
			case "U":
				if (data) {
					this.uiGenerator.AddTextElement("Nombre de personnes : " + (data.d.nbt * 2), "tableCount", this.configDiv);
				}
				else {
					if (this.zone == "Room_1_3") {
						this.uiGenerator.AddTextElement("Nombre de personnes : 26", "tableCount", this.configDiv);
					}
					else if (this.zone == "Room_4_7" || this.zone == "Room_8_11") {
						this.uiGenerator.AddTextElement("Nombre de personnes : 16", "tableCount", this.configDiv);
					}
				}

				switch(this.currentRoom) {
					case "2":
					case "3":
					case "2_3":
						afficherConfigEcranMural = false;
						break;
				}

				if (afficherConfigEcranMural) {
					var functionToSend = function(e){
						this.envGenerator.ChangeConfigValue({type: "isEcranMural", value: e.target.checked});
					}.bind(this);
					this.uiGenerator.AddCheckboxElement("Afficher ecran mural ", "isEcranMural", false, functionToSend, this.configDiv);
				}

				if (this.zone == "Room_1_3") {
					var functionToSend = function(e){
						this.envGenerator.ChangeConfigValue({type: "nbTableBaseU", value: e.target.value});
						this.uiGenerator.ChangeTextElement("nbTableBaseU-text", "Nombre de table a la base du U : " + this.envGenerator.GetConfigData().nbTableBaseU);
						this.uiGenerator.ChangeTextElement("tableCount", "Nombre de personnes : " + (this.envGenerator.GetConfigData().currentNbTable * 2));
					}.bind(this);
					this.uiGenerator.AddRangeInputElement("Nombre de table a la base du U : " + (data?data.d.nb:3), "nbTableBaseU", {default: data?data.d.nb:3, max:5, min:2, step: 1}, functionToSend, this.configDiv);
					
					var functionToSend = function(e){
						this.envGenerator.ChangeConfigValue({type: "nbTableU", value: e.target.value});
						this.uiGenerator.ChangeTextElement("nbTableU-text", "Nombre de table dans la longueur du U : " + this.envGenerator.GetConfigData().nbTableU);
						this.uiGenerator.ChangeTextElement("tableCount", "Nombre de personnes : " + (this.envGenerator.GetConfigData().currentNbTable * 2));
					}.bind(this);
					this.uiGenerator.AddRangeInputElement("Nombre de table dans la longueur du U : " + (data?data.d.n:5), "nbTableU", {default: data?data.d.n:5, max:8, min:1, step: 1}, functionToSend, this.configDiv);
				}
				else if (this.zone == "Room_4_7" || this.zone == "Room_8_11") {
					var functionToSend = function(e){
						this.envGenerator.ChangeConfigValue({type: "nbTableBaseU", value: e.target.value});
						this.uiGenerator.ChangeTextElement("nbTableBaseU-text", "Nombre de table a la base du U : " + this.envGenerator.GetConfigData().nbTableBaseU);
						this.uiGenerator.ChangeTextElement("tableCount", "Nombre de personnes : " + (this.envGenerator.GetConfigData().currentNbTable * 2));
					}.bind(this);
					this.uiGenerator.AddRangeInputElement("Nombre de table a la base du U : " + (data?data.d.nb:2), "nbTableBaseU", {default: data?data.d.nb:2, max:4, min:2, step: 1}, functionToSend, this.configDiv);
					

					var functionToSend = function(e){
						this.envGenerator.ChangeConfigValue({type: "nbTableU", value: e.target.value});
						this.uiGenerator.ChangeTextElement("nbTableU-text", "Nombre de table dans la longueur du U : " + this.envGenerator.GetConfigData().nbTableU);
						this.uiGenerator.ChangeTextElement("tableCount", "Nombre de personnes : " + (this.envGenerator.GetConfigData().currentNbTable * 2));
					}.bind(this);
					this.uiGenerator.AddRangeInputElement("Nombre de table dans la longueur du U : " + (data?data.d.n:3), "nbTableU", {default: data?data.d.n:3, max:12, min:1, step: 1}, functionToSend, this.configDiv);
				}
				break;
			case "Classe":
				if (data) {
					this.uiGenerator.AddTextElement("Nombre de personnes : " + (data.d.nbt * 2), "tableCount", this.configDiv);
				}
				else {
					switch(this.currentRoom) {
						case "1":
							this.uiGenerator.AddTextElement("Nombre de personnes : 80", "tableCount", this.configDiv);
							break;
						case "2":
							afficherConfigEcranMural = false;
							this.uiGenerator.AddTextElement("Nombre de personnes : 98", "tableCount", this.configDiv);
							break;
						case "3":
							afficherConfigEcranMural = false;
							this.uiGenerator.AddTextElement("Nombre de personnes : 70", "tableCount", this.configDiv);
							break;
						case "1_2":
							this.uiGenerator.AddTextElement("Nombre de personnes : 168", "tableCount", this.configDiv);
							break;
						case "2_3":
							afficherConfigEcranMural = false;
							this.uiGenerator.AddTextElement("Nombre de personnes : 180", "tableCount", this.configDiv);
							break;
						case "1_2_3":
							this.uiGenerator.AddTextElement("Nombre de personnes : 252", "tableCount", this.configDiv);
							break;
						case "4":
							this.uiGenerator.AddTextElement("Nombre de personnes : 12", "tableCount", this.configDiv);
							break;
						case "5":
							this.uiGenerator.AddTextElement("Nombre de personnes : 30", "tableCount", this.configDiv);
							break;
						case "6":
							this.uiGenerator.AddTextElement("Nombre de personnes : 48", "tableCount", this.configDiv);
							break;
						case "7":
							this.uiGenerator.AddTextElement("Nombre de personnes : 72", "tableCount", this.configDiv);
							break;
						case "8":
							this.uiGenerator.AddTextElement("Nombre de personnes : 16", "tableCount", this.configDiv);
							break;
						case "9":
							this.uiGenerator.AddTextElement("Nombre de personnes : 30", "tableCount", this.configDiv);
							break;
						case "10":
							this.uiGenerator.AddTextElement("Nombre de personnes : 48", "tableCount", this.configDiv);
							break;
						case "11":
							this.uiGenerator.AddTextElement("Nombre de personnes : 16", "tableCount", this.configDiv);
							break;
					}
				}

				if (afficherConfigEcranMural) {
						var functionToSend = function(e){
							this.envGenerator.ChangeConfigValue({type: "isEcranMural", value: e.target.checked});
						}.bind(this);
						this.uiGenerator.AddCheckboxElement("Afficher ecran mural ", "isEcranMural", false, functionToSend, this.configDiv);
					}

				if (this.zone == "Room_1_3") {
					var functionToSend = function(e){
						this.envGenerator.ChangeConfigValue({type: "praticable", value: e.target.checked});
					}.bind(this);
					this.uiGenerator.AddCheckboxElement("Avec praticable ", "praticable", false, functionToSend, this.configDiv);
				}

				var functionToSend = function(e){
					this.envGenerator.ChangeConfigValue({type: "entreTable", value: e.target.value/10});
					this.uiGenerator.ChangeTextElement("entreTable-text", "Espace entre les tables : " + ((e.target.value - 14) / 10) + "m");
					this.uiGenerator.ChangeTextElement("tableCount", "Nombre de personnes : " + (this.envGenerator.GetConfigData().tableCount * 2));
				}.bind(this);
				this.uiGenerator.AddRangeInputElement("Espace entre les tables : " + (data?(data.d.et*10-14)/10:0.6) + "m", "entreTable", {default: data?data.d.et*10:20, max:40, min:20, step: 1}, functionToSend, this.configDiv);

				functionToSend = function(e){
					this.envGenerator.ChangeConfigValue({type: "entreRange", value: e.target.value/10});
					this.uiGenerator.ChangeTextElement("entreRange-text", "Espace entre les rangés : " + ((e.target.value - 7) / 10) + "m");
					this.uiGenerator.ChangeTextElement("tableCount", "Nombre de personnes : " + (this.envGenerator.GetConfigData().tableCount * 2));
				}.bind(this);
				this.uiGenerator.AddRangeInputElement("Espace entre les rangés : " + (data?(data.d.er*10-7)/10:0.9) + "m", "entreRange", {default: data?data.d.er*10:16, max:30, min:16, step: 1}, functionToSend, this.configDiv);
				break;
			case "Travail":
				if (data) {
					this.uiGenerator.AddTextElement("Nombre de personnes : " + (data.d.nbt * 8), "poleCount", this.configDiv);
				}
				else {
					switch(this.currentRoom) {
						case "3":
							afficherConfigEcranMural = false;
						case "1":
							this.uiGenerator.AddTextElement("Nombre de personnes : 144", "poleCount", this.configDiv);
							break;
						case "2":
							afficherConfigEcranMural = false;
							this.uiGenerator.AddTextElement("Nombre de personnes : 216", "poleCount", this.configDiv);
							break;
						case "2_3":
							afficherConfigEcranMural = false;
						case "1_2":
							this.uiGenerator.AddTextElement("Nombre de personnes : 360", "poleCount", this.configDiv);
							break;
						case "1_2_3":
							this.uiGenerator.AddTextElement("Nombre de personnes : 504", "poleCount", this.configDiv);
							break;
						case "4":
							this.uiGenerator.AddTextElement("Nombre de personnes : 16", "poleCount", this.configDiv);
							break;
						case "5":
							this.uiGenerator.AddTextElement("Nombre de personnes : 40", "poleCount", this.configDiv);
							break;
						case "6":
							this.uiGenerator.AddTextElement("Nombre de personnes : 64", "poleCount", this.configDiv);
							break;
						case "7":
							this.uiGenerator.AddTextElement("Nombre de personnes : 96", "poleCount", this.configDiv);
							break;
						case "8":
							this.uiGenerator.AddTextElement("Nombre de personnes : 16", "poleCount", this.configDiv);
							break;
						case "9":
							this.uiGenerator.AddTextElement("Nombre de personnes : 40", "poleCount", this.configDiv);
							break;
						case "10":
							this.uiGenerator.AddTextElement("Nombre de personnes : 64", "poleCount", this.configDiv);
							break;
						case "11":
							this.uiGenerator.AddTextElement("Nombre de personnes : 88", "poleCount", this.configDiv);
							break;
					}
				}

				if (afficherConfigEcranMural) {
					var functionToSend = function(e){
						this.envGenerator.ChangeConfigValue({type: "isEcranMural", value: e.target.checked});
					}.bind(this);
					this.uiGenerator.AddCheckboxElement("Afficher ecran mural ", "isEcranMural", false, functionToSend, this.configDiv);
				}

				if (this.zone == "Room_1_3") {
					var functionToSend = function(e){
						this.envGenerator.ChangeConfigValue({type: "praticable", value: e.target.checked});
						this.uiGenerator.ChangeTextElement("poleCount", "Nombre de personnes : " + (this.envGenerator.GetConfigData().poleCount * 8));
					}.bind(this);
					this.uiGenerator.AddCheckboxElement("Avec praticable ", "praticable", false, functionToSend, this.configDiv);
				}
				
				var functionToSend = function(e){
					this.envGenerator.ChangeConfigValue({type: "entrePole", value: e.target.value/10});
					this.uiGenerator.ChangeTextElement("entrePole-text", "Distance entre minimum les pôles : " + ((e.target.value - 14) / 10) + "m");
					this.uiGenerator.ChangeTextElement("poleCount", "Nombre de personnes : " + (this.envGenerator.GetConfigData().poleCount * 8));
				}.bind(this);
				this.uiGenerator.AddRangeInputElement("Distance minimum entre les pôles : " + (data?(data.d.ep*10-14)/10:1.1) + "m", "entrePole", {default: data?data.d.ep*10:25, max:40, min:23, step: 1}, functionToSend, this.configDiv);
				break;

			case "Diner":
			case "Ronde":
				if (data) {
					this.uiGenerator.AddTextElement("Nombre de personnes : " + (data.d.nbt * data.d.ppt), "rondeCount", this.configDiv);
				}
				else {
					switch(this.currentRoom) {
						case "1":
							this.uiGenerator.AddTextElement("Nombre de personnes : 88", "rondeCount", this.configDiv);
							break;
						case "2":
							afficherConfigEcranMural = false;
							this.uiGenerator.AddTextElement("Nombre de personnes : 144", "rondeCount", this.configDiv);
							break;
						case "3":
							afficherConfigEcranMural = false;
							this.uiGenerator.AddTextElement("Nombre de personnes : 88", "rondeCount", this.configDiv);
							break;
						case "2_3":
							afficherConfigEcranMural = false;
						case "1_2":
							this.uiGenerator.AddTextElement("Nombre de personnes : 256", "rondeCount", this.configDiv);
							break;
						case "1_2_3":
							this.uiGenerator.AddTextElement("Nombre de personnes : 368", "rondeCount", this.configDiv);
							break;
						case "7":
							this.uiGenerator.AddTextElement("Nombre de personnes : 88", "rondeCount", this.configDiv);
							break;
						case "8":
							this.uiGenerator.AddTextElement("Nombre de personnes : 88", "rondeCount", this.configDiv);
							break;
						case "Lully":
							afficherConfigEcranMural = false;
							if (value == "Diner") {
								this.uiGenerator.AddTextElement("Nombre de personnes : 112", "rondeCount", this.configDiv);
							}
							else {
								this.uiGenerator.AddTextElement("Nombre de personnes : 256", "rondeCount", this.configDiv);
							}
							break;
					}
					if (afficherConfigEcranMural) {
						var functionToSend = function(e){
							this.envGenerator.ChangeConfigValue({type: "isEcranMural", value: e.target.checked});
						}.bind(this);
						this.uiGenerator.AddCheckboxElement("Afficher ecran mural ", "isEcranMural", false, functionToSend, this.configDiv);
					}
				}

				var functionToSend = function(e){
					this.envGenerator.ChangeConfigValue({type: "entreTable", value: e.target.value/10});
					this.uiGenerator.ChangeTextElement("entreTable-text", "Distance minimum entre les tables : " + ((e.target.value - 19) / 10) + "m");
					this.uiGenerator.ChangeTextElement("rondeCount", "Nombre de personnes : " + (this.envGenerator.GetConfigData().tableCount * this.envGenerator.GetConfigData().personneParTable));
				}.bind(this);
				this.uiGenerator.AddRangeInputElement("Distance minimum entre les tables : " + (data?(data.d.et*10-19)/10:1.1) + "m", "entreTable", {default: data?data.d.et*10:30, max:40, min:30, step: 1}, functionToSend, this.configDiv);
				
				var selectElementValue = {};
				selectElementValue.viewName = ["8", "9", "10"];
				selectElementValue.backName = ["8", "9", "10"];
				
				functionToSend = function(e){
					this.envGenerator.ChangeConfigValue({type: "personneParTable", value: e.target.value});
					this.uiGenerator.ChangeTextElement("rondeCount", "Nombre de personnes : " + (this.envGenerator.GetConfigData().tableCount * this.envGenerator.GetConfigData().personneParTable));
				}.bind(this);
				this.uiGenerator.AddSelectElement(selectElementValue, "Nombre de personne par table", "nbp_ronde", functionToSend, this.configDiv, data?data.d.ppt:null);


				break;
			case "Cocktail":
				if (data) {
					this.uiGenerator.AddTextElement("Nombre de mange debout : " + data.d.nbt, "cocktailCount", this.configDiv);
				}
				else {
					switch(this.currentRoom) {
						case "1":
							this.uiGenerator.AddTextElement("Nombre de mange debout : 14", "cocktailCount", this.configDiv);
							break;
						case "2":
							afficherConfigEcranMural = false;
							this.uiGenerator.AddTextElement("Nombre de mange debout : 13", "cocktailCount", this.configDiv);
							break;
						case "3":
							afficherConfigEcranMural = false;
							this.uiGenerator.AddTextElement("Nombre de mange debout : 7", "cocktailCount", this.configDiv);
							break;
						case "1_2":
							this.uiGenerator.AddTextElement("Nombre de mange debout : 23", "cocktailCount", this.configDiv);
							break;
						case "2_3":
							afficherConfigEcranMural = false;
							this.uiGenerator.AddTextElement("Nombre de mange debout : 20", "cocktailCount", this.configDiv);
							break;
						case "1_2_3":
							this.uiGenerator.AddTextElement("Nombre de mange debout : 30", "cocktailCount", this.configDiv);
							break;
						case "4":
							this.uiGenerator.AddTextElement("Nombre de mange debout : 2", "cocktailCount", this.configDiv);
							break;
						case "5":
							this.uiGenerator.AddTextElement("Nombre de mange debout : 3", "cocktailCount", this.configDiv);
							break;
						case "6":
							this.uiGenerator.AddTextElement("Nombre de mange debout : 6", "cocktailCount", this.configDiv);
							break;
						case "7":
							this.uiGenerator.AddTextElement("Nombre de mange debout : 9", "cocktailCount", this.configDiv);
							break;
						case "8":
							this.uiGenerator.AddTextElement("Nombre de mange debout : 2", "cocktailCount", this.configDiv);
							break;
						case "9":
							this.uiGenerator.AddTextElement("Nombre de mange debout : 3", "cocktailCount", this.configDiv);
							break;
						case "10":
							this.uiGenerator.AddTextElement("Nombre de mange debout : 8", "cocktailCount", this.configDiv);
							break;
						case "11":
							this.uiGenerator.AddTextElement("Nombre de mange debout : 11", "cocktailCount", this.configDiv);
							break;
						case "Lully":
							afficherConfigEcranMural = false;
							this.uiGenerator.AddTextElement("Nombre de mange debout : 25", "cocktailCount", this.configDiv);
							break;
					}
				}

				if (afficherConfigEcranMural) {
					var functionToSend = function(e){
						this.envGenerator.ChangeConfigValue({type: "isEcranMural", value: e.target.checked});
					}.bind(this);
					this.uiGenerator.AddCheckboxElement("Afficher ecran mural ", "isEcranMural", false, functionToSend, this.configDiv);
				}

				var functionToSend = function(e){
					this.envGenerator.ChangeConfigValue({type: "entreTable", value: e.target.value/10});
					this.uiGenerator.ChangeTextElement("entreTable-text", "Distance minimum entre les tables : " + ((e.target.value - 6) / 10) + "m");
					this.uiGenerator.ChangeTextElement("cocktailCount", "Nombre de mange debout : " + this.envGenerator.GetConfigData().cocktailCount);
				}.bind(this);
				this.uiGenerator.AddRangeInputElement("Distance minimum entre les tables : " + (data?(data.d.et*10-6)/10:1.9) + "m", "entreTable", {default: data?data.d.et*10:2, max:35, min:25, step: 1}, functionToSend, this.configDiv);
				break;
			case "Foyer":
				afficherConfigEcranMural = false;
				this.uiGenerator.AddTextElement("Aucune configuration n'est possible pour cet espace.", "foyerTexte", this.configDiv);
			case "Vide":
				if (afficherConfigEcranMural) {
					var functionToSend = function(e){
						this.envGenerator.ChangeConfigValue({type: "isEcranMural", value: e.target.checked});
					}.bind(this);
					this.uiGenerator.AddCheckboxElement("Afficher ecran mural ", "isEcranMural", false, functionToSend, this.configDiv);
				}
		}
	}

	ChangeRoom(value){
		this.envGenerator.ChangeRoom(value);
		this.currentRoom = value;
		var selectElementValue = {};
		var forceChange = false;

		/// DELETE Les deux checkbox pour les ajouter après si nécessaire
		var elem = document.getElementById("ecranMural");
		if (elem) {
			elem.parentElement.remove();
		}
		var elem = document.getElementById("isEcranMural");
		if (elem) {
			elem.parentElement.remove();
		}


		var afficherConfigEcranMural = true;

		switch(value) {
			case "1":
				if (this.currentConfigType == "Theatre") {
					var functionToSend = function(e){
						this.envGenerator.ChangeConfigValue({type: "switchOrientation", value: e.target.checked});
					}.bind(this);
					this.uiGenerator.AddCheckboxElement("Tourné écran mural ", "ecranMural", false, functionToSend, this.configDiv);
					var elemAdded = document.getElementById("ecranMural");
					var elemWhereMove = document.getElementById("praticable");
					elemAdded.parentElement.parentElement.insertBefore(elemAdded.parentElement, elemWhereMove.parentElement);
				}
			case "3":
				if (value == "3") {
					afficherConfigEcranMural = false;
				}
				selectElementValue.viewName = ["Théâtre", "U", "Classe", "Pôle de travail", "Table ronde", "Cocktail", "Vide"];
				selectElementValue.backName = ["Theatre", "U", "Classe", "Travail", "Ronde", "Cocktail", "Vide"];
				if (!selectElementValue.backName.includes(this.currentConfigType)) {
					this.currentConfigType = "Theatre";
					this.ChangeConfigType("Theatre");
					forceChange = true;
				}

				this.uiGenerator.ChangeSelectElement("config-type", selectElementValue, this.currentConfigType);
				break;
			case "2":
			case "2_3":
				afficherConfigEcranMural = false;
			case "1_2":
			case "1_2_3":
				selectElementValue.viewName = ["Théâtre", "Classe", "Pôle de travail", "Table ronde", "Cocktail", "Vide"];
				selectElementValue.backName = ["Theatre", "Classe", "Travail", "Ronde", "Cocktail", "Vide"];
				if (!selectElementValue.backName.includes(this.currentConfigType)) {
					this.currentConfigType = "Theatre";
					this.ChangeConfigType("Theatre");
					forceChange = true;
				}

				this.uiGenerator.ChangeSelectElement("config-type", selectElementValue, this.currentConfigType);
				break;

			case "4":
			case "5":
			case "6":
			case "9":
			case "10":
			case "11":
				selectElementValue.viewName = ["Théâtre", "U", "Classe", "Pôle de travail", "Cocktail", "Vide"];
				selectElementValue.backName = ["Theatre", "U", "Classe", "Travail", "Cocktail", "Vide"];
				if (!selectElementValue.backName.includes(this.currentConfigType)) {
					this.currentConfigType = "Theatre";
					this.ChangeConfigType("Theatre");
					forceChange = true;
				}

				this.uiGenerator.ChangeSelectElement("config-type", selectElementValue, this.currentConfigType);
				break;
			case "7":
			case "8":
				selectElementValue.viewName = ["Théâtre", "U", "Classe", "Pôle de travail", "Table ronde", "Cocktail", "Vide"];
				selectElementValue.backName = ["Theatre", "U", "Classe", "Travail", "Ronde", "Cocktail", "Vide"];
				if (!selectElementValue.backName.includes(this.currentConfigType)) {
					this.currentConfigType = "Theatre";
					this.ChangeConfigType("Theatre");
					forceChange = true;
				}

				this.uiGenerator.ChangeSelectElement("config-type", selectElementValue, this.currentConfigType);
				break;
			case "Lully":
				afficherConfigEcranMural = false;
				break;
			default:
		}

		if (afficherConfigEcranMural) {
			var functionToSend = function(e){
				this.envGenerator.ChangeConfigValue({type: "isEcranMural", value: e.target.checked});
			}.bind(this);

			this.uiGenerator.AddCheckboxElement("Afficher ecran mural ", "isEcranMural", this.envGenerator.configController.data.isEcranMural, functionToSend, this.configDiv);
			var elemAdded = document.getElementById("isEcranMural");
			var elemWhereMove = document.getElementById("praticable");

			if (elemWhereMove) {
				elemAdded.parentElement.parentElement.insertBefore(elemAdded.parentElement, elemWhereMove.parentElement);
			}
			else {
				elemWhereMove = document.getElementById("nbTableBaseU-text");
				if (elemWhereMove) {
					elemAdded.parentElement.parentElement.insertBefore(elemAdded.parentElement, elemWhereMove);
				}
				else {
					elemWhereMove = document.getElementById("entreRange-text");
					if (elemWhereMove) {
						elemAdded.parentElement.parentElement.insertBefore(elemAdded.parentElement, elemWhereMove);
					}
					else {
						elemWhereMove = document.getElementById("entreTable-text");
						if (elemWhereMove) {
							elemAdded.parentElement.parentElement.insertBefore(elemAdded.parentElement, elemWhereMove);
						}
						else {
							elemWhereMove = document.getElementById("entrePole-text");
							if (elemWhereMove) {
								elemAdded.parentElement.parentElement.insertBefore(elemAdded.parentElement, elemWhereMove);
							}
						}
					}
				}
			}
		}

		//// A checker si on peut enlever le if et le forçage du changement de config plus haut
		if (!forceChange) {
			this.envGenerator.ChangeConfigType(this.currentConfigType);
			switch(this.currentConfigType) {
				case "Theatre":
					this.uiGenerator.ChangeTextElement("chaiseCount", "Nombre de personne : " + this.envGenerator.GetConfigData().chaiseCount);
					break;
				case "U":
					this.uiGenerator.ChangeTextElement("tableCount", "Nombre de personnes : " + (this.envGenerator.GetConfigData().currentNbTable * 2));
					this.uiGenerator.ChangeTextElement("nbTableBaseU-text", "Nombre de table a la base du U : " + this.envGenerator.GetConfigData().nbTableBaseU);
					this.uiGenerator.ChangeTextElement("nbTableU-text", "Nombre de table dans la longueur du U : " + this.envGenerator.GetConfigData().nbTableU);
					break;
				case "Classe":
					this.uiGenerator.ChangeTextElement("tableCount", "Nombre de personnes : " + (this.envGenerator.GetConfigData().tableCount * 2));
					break;
				case "Travail":
					this.uiGenerator.ChangeTextElement("poleCount", "Nombre de personnes : " + (this.envGenerator.GetConfigData().poleCount * 8));
					break;
				case "Ronde":
					this.uiGenerator.ChangeTextElement("rondeCount", "Nombre de personnes : " + (this.envGenerator.GetConfigData().tableCount * 8));
					break;
				case "Cocktail":
					this.uiGenerator.ChangeTextElement("cocktailCount", "Nombre de mange debout : " + this.envGenerator.GetConfigData().cocktailCount);
					break;
			}
		}
	}

	SimsControllerFunction(functionName, data) {
		if (data) {
        	this.envGenerator.simsController.SimsFunction(functionName, data);
		}
		else {
        	this.envGenerator.simsController.SimsFunction(functionName);
		}
	}
}